import { ObjectSerializer, type SearchAllEvent } from '@repo/api-gw-sdk';
import { SSEEventDecoder } from 'assistant-stream/utils';

const parseSearchAllEvent = (data: string): SearchAllEvent[] => {
  let parsed: unknown;
  try {
    parsed = JSON.parse(data);
  } catch {
    return [];
  }
  if (parsed === null || typeof parsed !== 'object') {
    return [];
  }
  const event: SearchAllEvent = ObjectSerializer.deserialize(
    parsed,
    'SearchAllEvent',
    ''
  );
  return [event];
};

export async function* readSearchAllEvents(
  body: ReadableStream<Uint8Array>
): AsyncGenerator<SearchAllEvent> {
  const reader = body.getReader();
  const textDecoder = new TextDecoder();
  const sseDecoder = new SSEEventDecoder({ trailing: 'dispatch' });
  try {
    while (true) {
      const { done, value } = await reader.read();
      const chunk = textDecoder.decode(value, { stream: !done });
      for (const event of sseDecoder.push(chunk)) {
        yield* parseSearchAllEvent(event.data);
      }
      if (done) {
        break;
      }
    }
    const trailing = sseDecoder.flush();
    if (trailing) {
      yield* parseSearchAllEvent(trailing.data);
    }
  } finally {
    await reader.cancel().catch(() => undefined);
    reader.releaseLock();
  }
}
